// When billy-api was responsible for sending invitations (umbrellas-api has taken over) it would send both an id and code, we catch that here and redirect
module.exports = Em.Route.extend({
    model: function(params) {
        this.replaceWith('organization_invitation', params.id + '-' + params.code)
    }
})
